import { TableCell } from 'src/components/atoms'
import { TableSortableTxt, TableSortType } from 'src/components/molecules'
import { ExternalAssignUserSortItemType } from 'src/components/molecules/projects/ExternalAssignUserTableHead'

type Props = {
  sortItem: ExternalAssignUserSortItemType
  sortType: TableSortType
  onSelectItem: (newItem: ExternalAssignUserSortItemType) => void
  onSelectSortType: (newType: TableSortType) => void
  className?: string
}

export function ExternalAssignUserEditTableHead({
  sortItem,
  sortType,
  onSelectItem,
  onSelectSortType,
  className,
}: Props) {
  const handleOnSelectItem = (newItem: ExternalAssignUserSortItemType) => {
    if (sortItem === newItem) {
      onSelectSortType(sortType === 'asc' ? 'desc' : 'asc')
    } else {
      onSelectItem(newItem)
    }
  }

  return (
    <div className={className}>
      <div className="tw-flex tw-gap-s0 tw-bg-surface-secondary tw-py-s-1 tw-px-s0">
        <TableCell className="tw-w-full tw-shrink">
          <TableSortableTxt
            text="名前"
            isActive={sortItem === 'name'}
            sortType={sortType}
            onSelect={() => handleOnSelectItem('name')}
          />
        </TableCell>
        <TableCell width={15}>
          <TableSortableTxt
            text="メールアドレス"
            isActive={sortItem === 'email'}
            sortType={sortType}
            onSelect={() => handleOnSelectItem('email')}
          />
        </TableCell>
        <TableCell width={15}>
          <TableSortableTxt
            text="キーワード"
            isActive={sortItem === 'keywords'}
            sortType={sortType}
            onSelect={() => handleOnSelectItem('keywords')}
          />
        </TableCell>
        <TableCell width={12}>
          <TableSortableTxt
            text="アサイン日"
            isActive={sortItem === 'assignedAt'}
            sortType={sortType}
            onSelect={() => handleOnSelectItem('assignedAt')}
          />
        </TableCell>
        <TableCell width={28}>
          <TableSortableTxt
            text="ROOV compass権限"
            isActive={sortItem === 'compassRole'}
            sortType={sortType}
            onSelect={() => handleOnSelectItem('compassRole')}
          />
        </TableCell>
      </div>
    </div>
  )
}
